import CustomElement from '~utilities/custom-element';

const IS_LOADING = 'is--loading';

class AsyncElement extends CustomElement {
	constructor() {
		super();
		
		this.type = this.getAttribute('js-type');
		this.elementName = this.getAttribute('js-element');
		this.url = this.getAttribute('js-url');
	}
	
	template() {
        // SHOW PREVIEW TEMPLATE
		switch (this.elementName) {
			case 'c-card':
				return `<div class="c-card card--${this.type} ${IS_LOADING}"></div>`;
			default:
				return `<div class="async-element__preview is--loading"></div>`;
		}
	}

	callback(element = false) {
		super.callback(element);
		this.fetchData();
	}	
	
	
	fetchData() {
		fetch(this.url)
		.then(res => {
			return res.text();
		})
		.then(data => {
			this.innerHTML = data;
		})
        .catch((error) => {
		    this.innerHTML = `Element not loaded`;
            console.error(`AsyncElement: This element gives an error: ${this.elementName}, url: ${this.url}, error: ${error}`);
        });
	}
}

export default AsyncElement;